//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'

export default {
  props: {
    currentSteps: {
      type: Array,
      required: true,
    },
    isLastStep: {
      type: Boolean,
      required: false,
      default: false,
    },
    isStepperNextButtonEnabled: {
      type: Boolean,
      required: false,
      default: true,
    },
    currentStep: {
      type: String,
      required: true,
    },
    currentStepNumber: {
      type: Number,
      required: true,
    },
    currentStepSelectedCards: {
      type: Array,
      required: true,
    },
    currentStepMinCards: {
      type: Number,
      required: true,
    },
    currentStepMaxCards: {
      type: Number,
      required: true,
    },
    previousStepLink: {
      type: String,
      required: false,
      default: '',
    },
    nextStepLink: {
      type: String,
      required: false,
      default: '',
    },
    backButton: {
      type: String,
      required: false,
      default: '',
    },
    skipButton: {
      type: String,
      required: false,
      default: '',
    },
    nextButton: {
      type: String,
      required: true,
    },
    isRequiredStep: {
      type: Boolean,
      required: false,
      default: false,
    },
    isFinalStep: {
      type: Boolean,
      required: false,
      default: false,
    },
    isNextActionCustom: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      form: {
        customsubmit: '',
        language: '',
        cookieTrackFVisit: '',
        cookieTrackCode: '',
        cookieTrackExpires: '',
        server_currency: '',
        j: 0,
        profile: process.env.GA_PROFILE_NUM !== undefined ? process.env.GA_PROFILE_NUM : '',
      },
      isShowSelect: false,
    }
  },
  computed: {
    currentButtonText() {
      return this.isLastStep && this.isStepperNextButtonEnabled ? 'STEPS_BAR_BTN_ADD_TO_CART' : this.nextButton
      /* && currentStepMinCards */
    },
    queryString() {
      let string = ''
      let count = 1
      this.selectedCards.forEach((selected) => {
        string = string + 'p' + count + '=' + selected.CartId + '&' + 'qnt' + count + '=' + selected.Quantity + '&'
        this.form['p' + count] = selected.CartId
        this.form['qnt' + count] = 1
        count += 1
      })
      const lang = this.$services.culture.getLanguage()
      const currency = this.$services.culture.getCurrency()

      let TrackCode = ''
      const visitCookie = this.$services.cookies.get('visit')
      if (visitCookie != null && visitCookie.includes('=')) {
        TrackCode = visitCookie.split('=')[1].split('&')[0]
      }
      string =
        string +
        'j=' +
        this.selectedCards.length +
        '&server_currency=' +
        currency +
        '&profile=' +
        this.$config.CustomProductData.currentGAprofile +
        '&language=' +
        lang +
        '&cookieTrackCode=' +
        TrackCode
      return string
    },
    ...mapState({
      selectedCards: (state) => state.cards.selectedCards,
      reachedStepNumber: (state) => state.steps.reachedStepNumber,
      cards: (state) => state.cards.cards,
    }),
  },
  methods: {
    redirectToPrevLink(link) {
      this.$store.commit('steps/setIsRedirectBack')
      setTimeout(() => this.$router.push({ path: link }), 300)
    },
    navigateToDifferentRoute(link, index) {
      if (this.reachedStepNumber < index) {
        return
      }
      if (this.currentStepNumber < index) {
        this.$store.commit('steps/setIsisRedirectNext')
      }
      if (this.currentStepNumber > index) {
        this.$store.commit('steps/setIsRedirectBack')
      }
      setTimeout(() => this.$router.push({ path: link }), 300)
    },
    fillForm() {
      let string = ''
      let count = 1
      this.selectedCards.forEach((selected) => {
        string = string + 'p' + count + '=' + selected.CartId + '&' + 'qnt' + count + '=' + selected.Quantity + '&'
        this.form['p' + count] = selected.CartId
        this.form['qnt' + count] = 1
        count += 1
      })
      const lang = this.$services.culture.getLanguage()
      const currency = this.$services.culture.getCurrency()
      string =
        string +
        'j=' +
        this.selectedCards.length +
        '&server_currency=' +
        currency +
        '&profile=' +
        this.$config.CustomProductData.currentGAprofile +
        '&language=' +
        lang
      return string
    },
    confirmCart(link) {
      if (!this.isStepperNextButtonEnabled) {
        this.isShowSelect = !this.isShowSelect
        return
      }
      if (!this.isLastStep && this.isStepperNextButtonEnabled) {
        this.$store.commit('steps/setIsisRedirectNext')
        setTimeout(() => this.$router.push({ path: link }), 300)
      }
    },
  },
}
